import React from 'react';
import { DownloadProgress } from '../types';
import { X } from 'lucide-react';

interface DownloadProgressBarProps {
  progress: DownloadProgress;
  onRemove: (id: string) => void;
}

export const DownloadProgressBar: React.FC<DownloadProgressBarProps> = ({ progress, onRemove }) => {
  const getProgressColor = () => {
    switch (progress.status) {
      case 'completed':
        return 'bg-green-500';
      case 'error':
        return 'bg-red-500';
      case 'downloading':
        return 'bg-blue-500';
      default:
        return 'bg-gray-500';
    }
  };

  const getStatusIcon = () => {
    switch (progress.status) {
      case 'completed':
        return '✓';
      case 'error':
        return '✗';
      case 'downloading':
        return '⏳';
      default:
        return '○';
    }
  };

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-4 shadow-sm">
      <div className="flex items-center justify-between mb-2">
        <div className="flex items-center space-x-2">
          <span className="text-sm font-medium text-gray-900">
            {getStatusIcon()} {progress.filename}
          </span>
          {progress.status === 'downloading' && (
            <span className="text-xs text-gray-500">
              {progress.progress.toFixed(0)}%
            </span>
          )}
        </div>
        <button
          onClick={() => onRemove(progress.id)}
          className="text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="w-full bg-gray-200 rounded-full h-2">
        <div
          className={`h-2 rounded-full transition-all duration-300 ${getProgressColor()}`}
          style={{ width: `${progress.progress}%` }}
        ></div>
      </div>

      {progress.error && (
        <div className="mt-2 text-xs text-red-600">
          {progress.error}
        </div>
      )}

      {progress.status === 'completed' && (
        <div className="mt-2 text-xs text-green-600">
          下载完成
        </div>
      )}
    </div>
  );
};